import styled from 'styled-components';
export const MegaMenuStyled = styled.nav `
  width: 1200px;
  padding: 38px 50px;

  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0px 6px 12px 0px #00000033, 0px 0.8px 1.5px 0px #0000001a;

  position: relative;
  margin-top: 94px;
   {
    /*
      * TODO:
      * the above declaration implies that MegaMenu is aware of its surroundings, which it should not be
      * have had to compensate for this in the stories with a decorator
    */
  }
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%, 0);

  &::before {
    content: '';
    display: block;
    height: 36px;
    width: 100%;
    position: absolute;
    top: -36px;
    left: 0;
  }
`;
export const FooterSectionStyled = styled.div `
  margin-top: 48px;
`;
export const ImageLinksWrapperStyled = styled.div `
  display: grid;
  grid-template-columns: repeat(${(props) => props.columns}, 1fr);
  gap: 32px;
`;
//# sourceMappingURL=mega-menu.styles.js.map